<app-student-module [PrintOptions]="printOptions" ModuleName="Observational Data">
  <table class="table table-striped d-print-none">
    <thead>
    <tr>
      <th>Date</th>
      <th>
        <button-new (btnClick)="newObservation()" btnClass="btn-sm float-end"></button-new>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let o of observations">
      <td>{{ o.date | date : 'shortDate' }}</td>
      <td>
        <button-more (btnClick)="open(o)" btnClass="btn-sm float-end"></button-more>
      </td>
    </tr>
    </tbody>
  </table>
  <div class="d-none d-print-block">
    <ng-container *ngFor="let obs of observations">
      <hr/>
      <div class="row">
        <div class="col-6 fw-bold">Date</div>
        <div class="col">
          {{obs.date | date : 'shortDate'}}
        </div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Observation</div>
        <div class="col">
          {{obs.observation}}
        </div>
      </div>
      <div class="row" *ngIf="obs.observer_ids.length > 0">
        <div class="col-6 fw-bold">Observers</div>
        <div class="col">
          <ul class="list-group list-group-flush" *ngFor="let o of obs.observer_ids">
            <li class="list-group-item">{{ o | staffId | async }}</li>
          </ul>
        </div>
      </div>
      <div class="row" *ngIf="(obs.observer_str || '').length > 0">
        <div class="col-6 fw-bold">Other Observers</div>
        <div class="col">
          <pre>{{obs.observer_str}}</pre>
        </div>
      </div>
      <div class="row" *ngIf="(obs.academic_area || '').length > 0">
        <div class="col-6 fw-bold">Academic Area</div>
        <div class="col"><pre>{{obs.academic_area}}</pre></div>
      </div>
      <div class="row" *ngIf="(obs.activities || '').length > 0">
        <div class="col-6 fw-bold">Instructional Activities</div>
        <div class="col">
          <pre>{{obs.activities}}</pre>
        </div>
      </div>
      <div class="row" *ngIf="(obs.materials || '').length > 0">
        <div class="col-6 fw-bold">Instructional Materials</div>
        <div class="col">
          <pre>{{obs.materials}}</pre>
        </div>
      </div>
      <div class="row" *ngIf="(obs.presentation || '').length > 0">
        <div class="col-6 fw-bold">Manner of Presentation</div>
        <div class="col">
          <pre>{{obs.presentation}}</pre>
        </div>
      </div>
      <div class="row" *ngIf="(obs.observation || '').length > 0">
        <div class="col-6 fw-bold">Observations</div>
        <div class="col">
          <pre>{{obs.observation}}</pre>
        </div>
      </div>
      <div class="row" *ngIf="(obs.peer_comparison || '').length > 0">
        <div class="col-6 fw-bold">Peer Comparison</div>
        <div class="col">
          <pre>{{obs.peer_comparison}}</pre>
        </div>
      </div>
    </ng-container>
  </div>
</app-student-module>
